
function getPositions(box) {
    var $box = $(box);
    var pos = $box.offset();
    var width = $box.width();
    var height = $box.height();
    if (pos) {
        return [[pos.left, pos.left + width], [pos.top, pos.top + height]];
    } else return [];
}

function comparePositions(p1, p2) {
    if (p1[1] > p2[0] || p1[0] === p2[0]) {
        return true;
    } else return false;
}

const TYPE = {
    PLP: 1,
    RELATIVE: 2,
    MAIN: 4,
    SBL: 5,
    SEARCH: 6,
    MENU: 7,
    UNDEF: 8
};

/**
 @param {jQuery} $product
 @return {TYPE}
 */
function determineType(prodFrom) {
    switch (prodFrom) {
        case 'plp':
            return TYPE.PLP;
        case 'search':
            return TYPE.SEARCH;
        case 'menu':
            return TYPE.MENU;
        case 'recommendation':
            return TYPE.RELATIVE;
        case 'pdp':
            return TYPE.MAIN;
        case 'sbl':
            return TYPE.SBL;
        default:
            return TYPE.UNDEF;
    }
}


function getContainerFrom($container) {
    return $container.data('analyticsfrom');
}

function getContainerTemplate($container) {
    var template = $container.data('analyticstemplate');
    if (!template) {
        // plp fallback to avoid duplicate params and manage for switch
        template = $container.find('.js-plp-current-template').attr('data-currenttemplate');
    }
    return template;
}

function getProductTemplate($product, $container) {
    var prodTemplate = $product.attr('data-template');
    if (prodTemplate === 'retrieve' && $container) {
        var containerFrom = getContainerFrom($container);
        if (containerFrom === 'editorial') {
            prodTemplate = $product.closest('.js-promo').attr('data-creative');
        } else {
            var containerTemplate = getContainerTemplate($container);
            switch (containerTemplate) {
                case 'search/grid3Template':
                case 'search/plpLayout/grid3/searchResultNoDecorator':
                case '/search/plpLayout/grid3/productGrid':
                    prodTemplate = 'grid3';
                    break;
                case 'search/grid2Template':
                case 'search/plpLayout/grid2/searchResultNoDecorator':
                case '/search/plpLayout/grid2/productGrid':
                    prodTemplate = 'grid2';
                    break;
                default:
                    prodTemplate = containerTemplate;
                    break;
            }
        }
        $product.attr('data-template', prodTemplate);
    }
    return prodTemplate;
}

function getProductFrom($product, $container) {
    var prodFrom = $product.attr('data-from');
    if (prodFrom === 'retrieve' && $container) {
        var containerFrom = getContainerFrom($container);
        var containerTemplate = getContainerTemplate($container); // può essere diverso da quello di prodotto
        prodFrom = containerFrom;
        if (((containerFrom === 'pdp' || containerFrom === 'pdpLook') && containerTemplate === 'recommendation') || containerFrom === 'cart' || containerFrom === 'thankyou'){
            prodFrom = $container.find('.js-einstein-slick').length ? 'einstein' : 'recommendation';
        }
        $product.attr('data-from', prodFrom);
    }
    return prodFrom;
}

function getProductTag($product, $container) {
    if ($container) { // shows only tag within container anabled
        var containerEnabled = $container.attr('data-analyticstags') === "true";
        if (containerEnabled) {
            return $product.attr('data-tag-' + $product.data('color'));
        }
    }
    return '';
}

function getProduct3d($product, $container) {
    var prodTag = $product.attr('data-3d');
    if (prodTag && $container) { // shows only tag within container anabled
       var containerEnabled = $container.attr('data-analytics3d') === "true";
       if (!containerEnabled) {
            prodTag = ''; // if container doesn't enable tagging, i'll remove the value
            $product.attr('data-3d', prodTag);
       }
    }
    return prodTag;
}

function getCategoryGender(categoryId, sblList) {
    if (categoryId) {
        if (categoryId.indexOf('girl') !== -1) {
            return sblList ? 'kids_girl' : 'girls';
        } else if (categoryId.indexOf('boy') !== -1) {
            return sblList ? 'kids_boy' : 'boys';
        } else if (categoryId.indexOf('woman') !== -1) {
            return sblList ? 'woman' : 'female';
        } else if (categoryId.indexOf('man') !== -1) {
            return sblList ? 'man' : 'male';
        } else if (categoryId.indexOf('fragrances') !== -1) {
            return categoryId.indexOf('-m') !== -1 ? 'man' : 'woman';
        } else if (categoryId.indexOf('eyewear') !== -1) {
            return 'unisex';
        }
    }
    return '';
}

function getSBLGender(categoryId) {
    return getCategoryGender(categoryId, true);
}

function getProductList($product, prodFrom, prodTemplate) {
    var prodList = $product.attr('data-list');
    if (prodList === 'retrieve') {
        if (prodFrom === 'recommendation') {
            prodList = $('#searchList').val().replace('category-', 'relatives-');
        } else if (prodFrom === 'pdpLook') {
            if ('recommendation' === prodTemplate) {
                prodList = 'relatives-product-look';
            } else if ('pdp' === prodTemplate) {
                prodList = $('#searchList').val();
            } else {
                prodList = 'product-look';
            }
        } else if (prodFrom === 'editorial-relatives') {
            prodList = 'relatives-editorial-' + $('.storepage').attr('id');
        } else if (prodFrom === 'einstein') { // TODO: refactoring pending definire container
            prodList = $('#searchList').val().replace('category-', 'einstein-');
        } else if (prodFrom === 'editorial' || prodFrom === 'editorial-shoptheimage') {
            prodList = 'editorial-' + $('.storepage').attr('id')
            if (prodFrom === 'editorial-shoptheimage') {
                prodList += '-shop-the-image';
            }
        } else if (prodFrom === 'search') {
            prodList = 'search-suggested';
        } else if (prodFrom === 'menu') {
            var analyticsMenu = $product.parents('.js-navbar-item') ? $product.parents('.js-navbar-item').attr('data-analyticsmainmenu') : '';
            prodList = 'menu-' + analyticsMenu;
        } else if (prodFrom === 'sbl') {
            // prodList = 'shop-by-look-' + getSBLGender($product.attr('data-categoryid'));
            prodList = $('#searchList').val().replace('category-', 'pdp-');
        } else if (prodFrom === 'pdp') {
            prodList = '';
        } else {
            prodList = $('#searchList').val();
        }
        $product.attr('data-list', prodList);
    }
    return prodList;
}

function getProductPosition($product, $container) {
    var prodPosition = $product.attr('data-position');
    if (prodPosition === 'retrieve' && $container) {
        prodPosition = $container.find('.js-analytics-impressions-product-initialized').length + 1;
        $product.attr('data-position', prodPosition);
    }
    return prodPosition;
}

function getAnalyticsImage($product, $container) {
    var prodImage = $product.attr('data-img');
    if (prodImage === 'retrieve' && $container) {
        var containerFrom = getContainerFrom($container);
        if (containerFrom === 'editorial') {
            var parent = $product.closest('.js-analytics-impressions-image');
            var type = parent.attr('data-analyticsimage');
            prodImage = (parent.find('.cc-content-video').length > 0 ? 'video_' : 'img_' ) + type;
        } else if ($product.closest('.cc-product-tile')) {
            var parent = $product.closest('.cc-product-tile');
            if (parent.find('.js-analytics-impressions-image-vv').length) {
                prodImage = 'video_standard';
            } else if (parent.find('.js-analytics-impressions-image-vh').length) {
                prodImage = 'video_double';
            } else if (parent.find('.js-analytics-impressions-image-idh').length) {
                prodImage = 'img_double-hover';
            } else if (parent.find('.js-analytics-impressions-image-ifh').length) {
                prodImage = 'img_full-hover';
            } else if (parent.find('.js-analytics-impressions-image-ih').length) {
                prodImage = 'img_standard-hover';
            } else if (parent.find('.js-analytics-impressions-image-id').length) {
                prodImage = 'img_double';
            } else if (parent.find('.js-analytics-impressions-image-if').length) {
                prodImage = 'img_full';
            } else {
                prodImage = 'img_standard';
            }
        }
        $product.attr('data-img', prodImage);
    }
    return prodImage;
}

// dataLayerPush
function dataLayerPush(object) {
    setTimeout(function() { // setTimeout moves this function off the main thread to break long task
        dataLayer.push(object);
    }, 0);
};

/**
 * push user_data event to datalayer to update customer data
 * @param {*} e
 */
function analyticsPushUserData (e) {
    var login = $('.login.hidden').text();
    var visitorId = $('.visitorId.hidden').text();
    var cartItemNumber = $('.cartItemNumber.hidden').text();
    // var optin_sf = $('.optin_sf').text();

    dataLayerPush({
        // optin_sf: optin_sf,
        event: 'user_data',
        login: login,
        visitorId: visitorId,
        cartItemNumber: cartItemNumber
    });
};

/**
 * push content grouping event to datalayer to update page informartion
 * @param {*} e 
 * @param {*} data overring values for pageCategory, pagesubCategory, pageDetail
 *                 listingType or client_advisor_id only if should be pushed
 */
function analyticsPushPage (e, data) {
    // init fields if doesn't exist overriding value
    var pageCategory = (data && data.pageCategory) ? data.pageCategory : $('.pageCategory').text();
    var pagesubCategory = (data && data.pagesubCategory) ? data.pagesubCategory : $('.pagesubCategory').text();
    var pageDetail = (data && data.pageDetail) ? data.pageDetail : $('.pageDetail').text();

    // field common in all pages where override is useless
    var visitorShipping = $('.visitorShipping').text();
    var visitorCurrency = $('.visitorCurrency').text();
    var pageLanguage = $('.pageLanguage').text();
    var pageStatus = $('.pageStatus').text();

    var baseObject = {
        visitorShipping: visitorShipping,
        visitorCurrency: visitorCurrency,
        pageCategory: pageCategory,
        pagesubCategory: pagesubCategory,
        pageDetail: pageDetail,
        pageLanguage: pageLanguage,
        pageStatus: pageStatus
    };

    // field that should be pushed only if request by trigger
    if (data.listingType) {
        baseObject.listingType = data.listingType;
    }

    if (data.client_advisor_id) {
        baseObject.client_advisor_id = data.client_advisor_id;
    }

    dataLayerPush(baseObject);

    // trigger user_data on all page changes
    analyticsPushUserData(e);
};

function loadAnalyticsProduct(prodAnalytics) {
    var deferred = new $.Deferred();
    prodAnalytics.each(function (i, item) {
        var $item = $(item);
        if ($item.is(':empty')){
            var href = $item.attr('href');
            $.ajax({
                url: href,
                async: false
            }).done(function (data) {
                $item.append(data);
            }).fail(function(data) {
                deferred.reject(response);
            });
        }
    });
    deferred.resolve();
    return deferred.promise();
};

function checkPromo (promo, positionScroll, positionValue) {
    for (var i = 0; i < promo.length; i++) {
        var promoToCheck = $(promo[i]);
        var posPromo = promoToCheck.offset().top - $('.cc-content-header').height() * 1.1;
        var name;
        var position = i + 1;
        var isCtaAnchorate = promoToCheck.hasClass('cc-pd-cta-anchored');
        if ($('.storepage').length > 0) {
            name = $('.storepage').attr('id');
        } else {
            name = promoToCheck.attr('data-name');
        }
        var notToPrint = false;
        if (promoToCheck.attr('data-animated-slide')) {
            notToPrint = true;
        }
        if (isCtaAnchorate) {
            position = -1;
            posPromo = -1;
        }
        if (!notToPrint && (posPromo <= positionScroll) && !promoToCheck.hasClass('alreadyPrint')) {
            dataLayerPush({
                event: 'promoView',
                ecommerce: {
                    promoView: {
                        promotions: [{
                            id: promoToCheck.attr('data-id'),
                            name: name,
                            creative: promoToCheck.attr('data-creative'),
                            position: positionValue || i + 1
                        }]
                    }
                }
            });
            promoToCheck.addClass('alreadyPrint');
        }
        promoToCheck.attr('data-position', position);
    }
};

function checkPromoScrollHorizontal (promo, positionScroll) {
    for (var i = 0; i < promo.length; i++) {
        var promoToCheck = $(promo[i]);
        var posPromo = promoToCheck.width() * i - promoToCheck.width() * 0.5;
        var name;
        if ($('.storepage').length > 0) {
            name = $('.storepage').attr('id');
        } else {
            name = promoToCheck.data('name');
        }
        var notToPrint = false;
        if (promoToCheck.data('animated-slide')) {
            notToPrint = true;
        }
        if (!notToPrint && (posPromo <= positionScroll || i === 0) && !promoToCheck.hasClass('alreadyPrint')) {
            dataLayerPush({
                event: 'promoView',
                ecommerce: {
                    promoView: {
                        promotions: [{
                            id: promoToCheck.data('id'),
                            name: name,
                            creative: promoToCheck.data('creative'),
                            position: i + 1
                        }]
                    }
                }
            });
            promoToCheck.addClass('alreadyPrint');
        }
        promoToCheck.data('position', i + 1);
    }
};

function checkCollisionsProducts(products, posBlock, container) {
    if (products) {
        var prodCurrency = $('.visitorCurrency').text(); // taken from analytics-generate controller
        var pageAction = $('.page').data('action');
        var analyticsFrom = getContainerFrom(container);

        for (var i = 0; i < products.length; i++) {
            // retrieve product info
            var product = $(products[i]);
            var prodPid = product.attr('data-pid'); // skuMaster
            var prodName = product.attr('data-name');
            var prodPrice = product.attr('data-price');
            var prodPromotions = product.attr('data-promotions');
            var prodColor = product.attr('data-color');
            var prodGender = product.attr('data-gender');
            var prodAnalyticsColor = product.attr('data-color-' + prodColor);
            var prodUrl = product.attr('data-url');
            var prodAvailable = product.attr('data-available');
            var prodVideo = product.attr('data-video');
            var productIsSet = product.attr('data-isset') || false;
            var prodTemplate = getProductTemplate(product, container);
            var prodFrom = getProductFrom(product, container);
            var prodList = getProductList(product, prodFrom);
            var type = determineType(prodFrom);
            var prodPosition = getProductPosition(product, container);
            var sizeImg = getAnalyticsImage(product, container);
            var prod3d = getProduct3d(product, container);
            var prodTag = getProductTag(product, container);
            // used in product position to complete product initialization before the impression push
            product.addClass('js-analytics-impressions-product-initialized');

            if (pageAction !== 'Search-Show' || prodTemplate === 'wallTemplate') {
                if (prodList.indexOf('shop-by-look') !== -1 && pageAction === 'Product-Show') {
                    var productDiv = product.closest('.cc-list-col').length > 0 ? product.closest('.cc-list-col') : products[i];
                } else {
                    if (product.closest('.js-singleItem-plp').length > 0) {
                        productDiv = product.closest('.js-singleItem-plp');
                    } else if (prodFrom === 'editorial-shoptheimage') {
                        productDiv = products[i];
                    } else {
                        productDiv = product.closest('.row').length > 0 ? product.closest('.row') : products[i];
                    }
                }
            } else productDiv = products[i];
            if ((pageAction === 'Account-Show' || pageAction === 'Wishlist-ShowWishlist') && product.closest('.cc-wishlist-item').length > 0) {
                productDiv = product.closest('.cc-wishlist-item');
            }
            var posBomb = getPositions(productDiv);

            var horizontalMatch = comparePositions(posBlock[0], posBomb[0]);
            var verticalMatch = comparePositions(posBlock[1], posBomb[1]);
            var match = horizontalMatch && verticalMatch;

            if (prodFrom === 'recommendation' && (analyticsFrom === 'cart' || analyticsFrom === 'thankyou') && $(window).width() > 767) {
                var posProduct = product.parent().offset().top;
                var actPos = $('.js-analytics-impressions-block-scroll').offset().top;
                match = posProduct <= actPos;
            } else if (prodFrom === 'recommendation' || prodFrom === 'einstein' || prodFrom === 'editorial-relatives') {
                // prevent impression push before slick is loaded in pdp, or editorial pages
                if (!product.closest('.slick-slide').hasClass('slick-active')) {
                    match = false;
                }
            }

            if (prodFrom === 'search') {
                if (!$('.id-js-searchIcon').data('open') && product.closest('.no-search-results-suggestions').length < 1) {
                    match = false;
                }
                if (product.closest('.cc-item').offset().top === 0) {
                    match = false;
                }
            }

            if (prodFrom === 'menu') {
                // prevent impression to be pushed before opening the menu section containing target products
                if (product.closest('.js-menu-overlay').hasClass('d-none')) {
                    match = false;
                }
            }

            if (prodFrom === 'editorial-shoptheimage') {
                // prevent impression to be sended before opening the shop the image modal
                if (!product.parents('.cc-pd-shop-the-image').hasClass('cc-open')) {
                    match = false;
                }
            }

            if (prodList === 'editorial') {
                var positionScroll = window.pageYOffset;
                var posProduct = product.offset().top;
                if (posProduct <= positionScroll) {
                    var matchEditorial = true;
                }
            }

            if (match || matchEditorial) {
                if (prodFrom === 'pdp' && type === TYPE.MAIN) {
                    dataLayerPush({
                        event: 'productDetail',
                        ecommerce: {
                            currencyCode: prodCurrency,
                            dimension27: prodVideo,
                            detail: {
                                products: [{
                                    name: prodName,
                                    id: prodPid,
                                    price: prodPrice,
                                    category: prodUrl,
                                    variant: prodColor,
                                    color: prodAnalyticsColor,
                                    gender: prodGender,
                                    dimension14: prodAvailable,
                                    dimension26: prodPromotions,
                                    callout: prodTag,
                                    '3dEnabled': prod3d
                                }]
                            }
                        }
                    });

                    $(document).trigger('pdp:productDetailEventPushed');
                } else {
                    dataLayerPush({
                        event: 'productImpression',
                        ecommerce: {
                            currencyCode: prodCurrency,
                            dimension25: prodFrom === 'plp' ? prodTemplate : '',
                            impressions: [
                                {
                                    name: prodName,
                                    id: prodPid,
                                    price: prodPrice,
                                    category: prodUrl,
                                    variant: prodColor,
                                    tileType: sizeImg,
                                    color: prodAnalyticsColor,
                                    gender: prodGender,
                                    list: prodList,
                                    position: prodPosition,
                                    dimension14: productIsSet ? '' : prodAvailable,
                                    dimension26: prodPromotions,
                                    callout: prodTag,
                                    '3dEnabled': prod3d
                                }
                            ]
                        }
                    });
                }

                product.removeClass('js-analytics-impressions-product-not-impressed').addClass('js-analytics-impressions-product-impressed');
            }
        }
    }
};

function checkContainerCollisionNotImpressed(container, esclusionSelector){
    var products = container.find('.js-analytics-impressions-product-not-impressed');
    if (esclusionSelector) {
        products = products.filter(function(i) {
            var product = $(this);
            return product.closest(esclusionSelector).length === 0;
        });
    }
    if (products.length > 0) {
        var posBlock = getPositions($('.js-analytics-impressions-block-scroll'));
        checkCollisionsProducts(products, posBlock, container);
    }
}

function checkCollisionNotImpressed(containers, esclusionSelector) {
    containers.each(function(index) {
        var container = $(this);
        if (container.attr('data-analyticsfrom') && container.attr('data-analyticsfrom') === 'wishlist'){
            // wishlist loading is async, product analytics should be loaded before sending impression 
            var prodAnalytics = $('.js-analytics-wishlist');
            loadAnalyticsProduct(prodAnalytics).done(function() {
                checkContainerCollisionNotImpressed(container, esclusionSelector);
            });
        } else {
            checkContainerCollisionNotImpressed(container, esclusionSelector);
        }
    });
};

function analyticsCheckImpressionAndPromo(e) {
    // product impressions in the current page
    checkCollisionNotImpressed($('.js-analytics-impressions-block-load'), '.js-analytics-impressions-relatives-load');
    // product impressions contained in carousel / shop the images / etc - that have diff from attribute
    checkCollisionNotImpressed($('.js-analytics-impressions-relatives-load'));
    var promo = $('.js-promo').not('.cc-pd-slider-progression .js-promo');
    var positionScroll = window.pageYOffset;
    if ($('.cc-horizontal-scroll-item').length > 0 && window.isDesktop) {
        checkPromoScrollHorizontal(promo, positionScroll);
    } else checkPromo(promo, positionScroll);
};

function pushAddToCart (product) {
    var $product = $(product);
    var prodPid = $product.attr('data-pid');
    var prodName = $product.attr('data-name');
    var prodCurrency = $('.visitorCurrency').text();
    var prodPrice = $product.attr('data-price');
    var prodPromotions = $product.attr('data-promotions');
    var prodColor = $product.attr('data-color');
    var prodGender = $product.attr('data-gender');
    var prodAnalyticsColor = $product.attr('data-color-' + prodColor);
    var prodUrl = $product.attr('data-url');
    var sizeImg = getAnalyticsImage($product);
    var prodFrom = getProductFrom($product);
    var prodList = getProductList($product, prodFrom);
    var prod3d = $product.attr('data-3d');
    var prodTag = $product.attr('data-tag');
    var prodSizeCode = $product.attr('data-size');
    var prodSticky = $product.attr('data-sticky');
    var prodVideo = $product.attr('data-video');

    var isPDPLook = false;
    if ($('.add-to-cart').hasClass('js-add-to-cart-sticky-look')) {
        isPDPLook = true;
        var selectedElement = $('.js-color-choiche-sticky-look.cc-active');
        var productVariationGroup = selectedElement.attr('data-id');
        prodColor = selectedElement.attr('data-attr-value');
        prodAnalyticsColor = $('.js-pdp-variation-look[data-pid="' + productVariationGroup + '"]').find('.new-analytics').attr('data-color-' + prodColor);
        prodSizeCode = $('.js-select-size.cc-active').attr('data-attr-value');
    }

    var prodSize = $product.attr('data-size-' + prodSizeCode);

    if (isPDPLook) {
        dataLayerPush({
            event: 'addToCart',
            ecommerce: {
                currencyCode: prodCurrency,
                add: {
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        dimension21: prodSize,
                        dimension22: 'product-look',
                        dimension26: prodPromotions,
                        dimension27: false,
                        quantity: 1,
                        color: prodAnalyticsColor,
                        gender: prodGender
                    }]
                }
            }
        });
    } else {
        dataLayerPush({
            event: 'addToCart',
            ecommerce: {
                currencyCode: prodCurrency,
                add: {
                    actionField: { list: prodList },
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        color: prodAnalyticsColor,
                        gender: prodGender,
                        dimension21: prodSize,
                        dimension22: prodSticky || prodFrom,
                        dimension26: prodPromotions,
                        dimension27: prodVideo,
                        quantity: 1,
                        tileType: prodFrom === 'pdp' ? '' : sizeImg,
                        callout: prodTag,
                        '3dEnabled': prod3d
                    }]
                }
            }
        });
    }
};

function pushRemoveFromCart (selector, prodQuantity, fromWhere, oncomplete) {
    var product = $(selector);
    // all product info
    var prodPid = product.data('pid');
    var prodName = product.data('name');
    var prodCurrency = $('.visitorCurrency').text();
    var prodPrice = product.data('price');
    var prodPromotions = product.data('promotions');
    var prodColor = product.data('color');
    var prodGender = product.data('gender');
    var prodAnalyticsColor = product.attr('data-color-' + prodColor);
    var prodUrl = product.data('url');
    var sizeAnalytics = product.attr('data-size-' + product.data('size'));
    var fromEventName = fromWhere === 'minicart' ? 'FromMinicart' : 'FromCart';

    dataLayerPush({
        event: 'remove' + fromEventName,
        ecommerce: {
            currencyCode: prodCurrency,
            remove: {
                products: [{
                    name: prodName,
                    id: prodPid,
                    price: prodPrice,
                    category: prodUrl,
                    variant: prodColor,
                    color: prodAnalyticsColor,
                    gender: prodGender,
                    dimension21: sizeAnalytics,
                    dimension26: prodPromotions,
                    quantity: prodQuantity
                }]
            }
        }
    });
    if (oncomplete) {
        oncomplete(selector);
    }
};

function pushChangeQuantity (selector, type, fromWhere) {

    var product = $(selector);

    // all product info
    var prodPid = product.data('pid');
    var prodName = product.data('name');
    var prodCurrency = $('.visitorCurrency').text();
    var prodPrice = product.data('price');
    var prodPromotions = product.data('promotions');
    var prodColor = product.data('color');
    var prodGender = product.data('gender');
    var prodAnalyticsColor = product.attr('data-color-' + prodColor);
    var prodUrl = product.data('url');
    var fromEventName = fromWhere === 'minicart' ? 'FromMinicart' : 'FromCart';
    var sizeAnalytics = product.attr('data-size-' + product.data('size'));

    if (type === 'up') {
        dataLayerPush({
            event: 'addToCart' + fromEventName,
            ecommerce: {
                currencyCode: prodCurrency,
                add: {
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        color: prodAnalyticsColor,
                        gender: prodGender,
                        dimension21: sizeAnalytics,
                        dimension22: fromWhere ? fromWhere : 'cart',
                        dimension26: prodPromotions,
                        quantity: 1
                    }]
                }
            }
        });
    } else if (type === 'down') {
        dataLayerPush({
            event: 'remove' + fromEventName,
            ecommerce: {
                currencyCode: prodCurrency,
                remove: {
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        color: prodAnalyticsColor,
                        gender: prodGender,
                        dimension21: sizeAnalytics,
                        dimension26: prodPromotions,
                        quantity: 1
                    }]
                }
            }
        });
    }
}

function analyticsPushPromoClick(currentTarget, $promo) {
    var position = $promo.attr('data-position');
    var contentButtons = $(currentTarget).parents('.cc-content-buttons');
    if (contentButtons.length > 0) {
        var clickableElements = contentButtons.find('.js-promo-click');
        if (clickableElements.length > 1) {
            var subPosition = clickableElements[0] === currentTarget ? '1' : '2';
            position += '-' + subPosition;
        }
    }
    let object = {
        promoClick: {
            promotions: [{
                id: $promo.attr('data-id'),
                name: $('.storepage').length > 0 ? $('.storepage').attr('id') : $promo.attr('data-name'),
                creative: $promo.attr('data-creative'),
                position: position
            }]
        },
        promo_text: currentTarget.innerText
    }
    let data = {event: "promoClick", ecommerce: object}

    dataLayerPush(data);
};


function analyticsPushChangeVariation(currentTarget) {
    var product;
    var $this = $(currentTarget);

    if ($this.hasClass('js-color-choiche-sticky-look')) {
        var productName = $('.js-analytics-look-product').attr('data-name');
        dataLayerPush({
            event: 'custom_event',
            eventCategory: 'Product Look Detail Page',
            eventAction: 'color select',
            eventLabel: productName
        });
    } else {
        // get product
        if (!$('.product-detail.cc-pdp').length) {
            product = $this.closest('.cc-info-section').parent().children('.cc-image-section').children('.js-analytics-impressions-product-impressed');
        } else {
            var wrapper = $this.closest('.cc-pdp__wrp');
            if ($this.parents('.js-sticky-add-to-cart').length) {
                wrapper = $this.closest('.product-detail').find('.cc-pdp__wrp');
            }
            product = wrapper.children('.cc-pdp__images').children('.js-analytics-impressions-product-impressed');
        }

        // execute switch
        var newColor = $this.data('attr-value');
        product.attr('data-color', newColor);

        // all product info
        var prodPid = product.attr('data-pid');
        var prodName = product.attr('data-name');
        var prodCurrency = $('.visitorCurrency').text();
        var prodPrice = product.attr('data-price');
        var prodPromotions = product.attr('data-promotions');
        var prodGender = product.attr('data-gender');
        var prodUrl = product.attr('data-url');
        var prodAvailable = product.attr('data-available');
        var prodVideo = product.attr('data-video');
        var prod3d = product.attr('data-3d');
        var prodAnalyticsColor = product.attr('data-color-' + newColor);
        var prodAnalyticsTag = product.attr('data-tag-' + newColor);

        dataLayerPush({
            event: 'productDetail',
            ecommerce: {
                currencyCode: prodCurrency,
                dimension27: prodVideo,
                detail: {
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: newColor,
                        color: prodAnalyticsColor,
                        gender: prodGender,
                        dimension14: prodAvailable,
                        dimension26: prodPromotions,
                        callout: prodAnalyticsTag,
                        '3dEnabled': prod3d
                    }]
                }
            }
        });
    }
};

function analyticsPushProductClick (product) {
    // all product info processed on page load, should be evaluated
    var prodPid = product.attr('data-pid');
    var prodName = product.attr('data-name');
    var prodCurrency = $('.visitorCurrency').text();
    var prodPrice = product.attr('data-price');
    var prodGender = product.attr('data-gender');
    var prodPromotions = product.attr('data-promotions');
    var prodColor = product.attr('data-color');
    var prodAnalyticsColor = product.attr('data-color-' + prodColor);
    var prodUrl = product.attr('data-url');
    var prodAvailable = product.attr('data-available');
    var prodTemplate = getProductTemplate(product);
    var prodFrom = getProductFrom(product);
    var prodList = getProductList(product, prodFrom);
    var prodPosition = getProductPosition(product);
    var sizeImg = getAnalyticsImage(product);
    var productIsSet = product.attr('data-isset') || false;
    var prod3d = product.attr('data-3d');
    var prodTag = product.attr('data-tag');

    if (prodTemplate && prodTemplate === 'pdpLook') {
            dataLayerPush({
                event: 'productClick',
                ecommerce: {
                    currencyCode: prodCurrency,
                    impressions: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        list: prodList,
                        position: prodPosition,
                        dimension14: prodAvailable,
                        dimension26: prodPromotions,
                        tileType: sizeImg,
                        color: prodAnalyticsColor,
                        gender: prodGender
                    }]
                }
            });
            dataLayerPush({
                event: 'productDetail',
                ecommerce: {
                    currencyCode: prodCurrency,
                    dimension27: false,
                    detail: {
                        products: [{
                            name: prodName,
                            id: prodPid,
                            price: prodPrice,
                            category: prodUrl,
                            variant: prodColor,
                            dimension14: prodAvailable,
                            dimension26: prodPromotions,
                            quantity: 1,
                            color: prodAnalyticsColor,
                            gender: prodGender,
                            callout: prodTag,
                            '3dEnabled': prod3d
                        }]
                    }
                }
            });
    } else {
        dataLayerPush({
            event: 'productClick',
            ecommerce: {
                currencyCode: prodCurrency,
                dimension25: prodFrom === 'plp' ? prodTemplate : '',
                click: {
                    actionField: { list: prodList },
                    products: [{
                        name: prodName,
                        id: prodPid,
                        price: prodPrice,
                        category: prodUrl,
                        variant: prodColor,
                        color: prodAnalyticsColor,
                        gender: prodGender,
                        position: prodPosition,
                        dimension14: productIsSet ? '' : prodAvailable,
                        dimension26: prodPromotions,
                        tileType: sizeImg,
                        callout: prodTag,
                        '3dEnabled': prod3d
                    }]
                }
            }
        });
    }
};

function initializeProducts (containerSelector) {
    var products = [];
    $(containerSelector + ' .js-analytics-impressions-product-not-impressed').each(function (index) {
        // get product by pid
        var product = $(this);
        // all product info
        var prodPid = product.data('pid');
        var prodName = product.data('name');
        var prodPrice = product.data('price');
        var prodPromotions = product.data('promotions');
        var prodColor = product.data('color');
        var prodGender = product.data('gender');
        var prodAnalyticsColor = product.attr('data-color-' + prodColor);
        var prodUrl = product.data('url');
        var prodSize = product.attr('data-size-' + product.data('size'));
        var prodQuantity = product.data('quantity');

        products.push({
            name: prodName,
            id: prodPid,
            price: prodPrice,
            category: prodUrl,
            variant: prodColor,
            color: prodAnalyticsColor,
            gender: prodGender,
            dimension21: prodSize,
            dimension26: prodPromotions,
            quantity: prodQuantity
        });
    });
    return products;
};

function pushCheckoutObject (products, step, step_type){
    var prodCurrency = $('.visitorCurrency').text();
    var obj = {
        event: 'checkout',
        ecommerce: {
            currencyCode: prodCurrency,
            checkout: {
                actionField: { step: step },
                products: products
            }
        }
    };
    if (step_type) {
        obj['step_type'] = step_type;
    }

    dataLayerPush(obj);
}

function pushPurchaseObject (products) {
    var prodCurrency = $('.visitorCurrency').text();
    dataLayerPush({
        'event': 'purchase',
        'shipping_method': $('#js-analytics-type-shipping').val(),
        'boutiqueName': $('#js-analytics-boutique').val(),
        'typ_type': $('#js-thankyoupage-type').val(),
        'ecommerce': {
            'currencyCode': prodCurrency,
            'purchase': {
                'actionField': {
                    'id': $('#js-analytics-id').val(),
                    'revenue': $('#js-analytics-revenue-datalayer').val(),
                    'tax': $('#js-analytics-tax-datalayer').val(),
                    'shipping': $('#js-analytics-shipping-datalayer').val(),
                    'coupon': $('#js-analytics-coupon').val(),
                    'dimension8': $('#js-analytics-dimension').val()
                },
                'products': products
            }
        }
    });
}

module.exports = {
    dataLayerPush: dataLayerPush,
    analyticsPushPage: analyticsPushPage,
    analyticsPushUserData: analyticsPushUserData,
    analyticsPushPromoClick: analyticsPushPromoClick,
    analyticsPushChangeVariation: analyticsPushChangeVariation,
    analyticsPushProductClick: analyticsPushProductClick,
    pushAddToCart: pushAddToCart,
    pushRemoveFromCart: pushRemoveFromCart,
    pushChangeQuantity: pushChangeQuantity,
    loadAnalyticsProduct: loadAnalyticsProduct,
    checkPromo: checkPromo,
    checkCollisionNotImpressed: checkCollisionNotImpressed,
    analyticsCheckImpressionAndPromo: analyticsCheckImpressionAndPromo,
    initializeCheckoutProducts: initializeProducts,
    pushCheckoutObject: pushCheckoutObject,
    pushPurchaseObject: pushPurchaseObject
};
